import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import useRequestStore from '../../../store/request';
import { useState } from 'react';

export default function RequestConsultingInfo({ next, back }) {
  const data = useRequestStore((state) => state.data);
  const [concept, setConcept] = useState(data.concept || 'digitization');

  function handleSubmit(evt) {
    evt.preventDefault();
    next({ concept });
  }

  function handleBack() {
    back({ concept });
  }

  return (
    <Box
      component="form"
      onSubmit={(evt) => handleSubmit(evt)}
      sx={{ display: 'flex', flexFlow: 'column', gap: '16px' }}
    >
      <FormControl>
        <InputLabel id="conceptLabel">Typ des Konzepts</InputLabel>
        <Select
          label="Typ des Konzepts"
          labelId="conceptLabel"
          value={concept}
          onChange={(evt) => {
            setConcept(evt.target.value);
          }}
        >
          <MenuItem value="digitization">Prozessdigitalisierung</MenuItem>
          <MenuItem value="security">IT-Sicherheitskonzept</MenuItem>
          <MenuItem value="cloud">Cloudinfrastruktur</MenuItem>
        </Select>
      </FormControl>
      <Button
        type="submit"
        variant="contained"
        sx={{
          borderRadius: 0,
          color: 'white',
          boxShadow: 'none !important',
          '&:hover': {
            backgroundColor: '#19BB5D',
          },
        }}
      >
        Weiter
      </Button>
      <Button
        onClick={handleBack}
        name="back"
        variant="text"
        sx={{ mt: '-8px' }}
      >
        Zurück
      </Button>
    </Box>
  );
}
